import axios from 'axios'
import { ALTERAR_ORDEM_TRECHO } from '../types'
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil'
import { URL } from '../../util/ambienteActions';

export default function alterarOrdem (idTrecho, idEmpresa, ordem) {
  const url = `${URL}/trecho/${idTrecho}/empresa/${idEmpresa}/ordem/${ordem}/alterar-ordem`;
  return dispatch => axios.post(url, null, SLOW_REQUEST_CONFIG).then(
      response => dispatch({
        type: ALTERAR_ORDEM_TRECHO,
        payload: response
      })
  );
}
